module.exports = __webpack_public_path__ + "static/clientele-8190617db19a98c68f18cb77bbc4d8e1.jpg";